<template>
  <div class="zs" :class="{ isiOSX: isiOSX }">
    <van-nav-bar class="invest-title" :fixed="true" title="确认订单" />
    <img
      class="invest-reback"
      @click="prev"
      src="../../assets/myInvest/reback.png"
    />
    <div class="addIn">
      <van-row class="prepare">
        <van-col span="24" class="prepare_">
          <span class="border"></span>
          <span class="add-head">项目详情</span>
        </van-col>
        <van-col span="24" class="moments">
          <div class="moments_">
            <p class="project">参与项目：{{ info.project_name }}</p>
            <p v-if="info.project_type == 1">
              总股数：<span>{{ info.target_shares }}</span
              >股
            </p>
            <!--<p v-if="info.project_type==2 && info.member_order_exist">总股数：<span>∞</span>股</p>-->
            <p v-if="info.order_count && info.member_order_exist">
              目前认购股数：{{ info.order_count.shares_sum }}股
            </p>
            <p>每股单价：¥{{ info.share_price }}</p>
            <p class="per_money">项目描述：{{ info.intro }}</p>
          </div>
        </van-col>
      </van-row>
      <van-row class="details prepare">
        <van-col class="prepare_" span="24">
          <span class="border"></span>
          <span class="add-head">参与详情</span>
        </van-col>
        <van-col span="24" class="prepare_">
          <p class="join_num">
            参与股数：<span>{{ purchaseNum }}</span>
          </p>
          <p>
            每股单价：<span>¥{{ price_1 }}.</span
            ><span class="zero">{{ price_2 }}</span>
          </p>
          <p class="total">
            合计金额：<span>¥{{ amount_1 }}.</span
            ><span class="zero">{{ amount_2 }}</span>
          </p>
        </van-col>
      </van-row>
    </div>
    <van-goods-action>
      <button ref="btn" @click="investPay()" style="display: none"></button>
      <van-button size="large" @click="submit">提交订单</van-button>
    </van-goods-action>
  </div>
</template>
<script>
export default {
  data() {
    return {
      purchaseNum: 0,
      info: {},
      price_1: 0,
      price_2: 0,
      amount_1: 0,
      amount_2: 0,
      isiOSX: false,
      order_id: 0,
      client: 0, //客户端类型 10：安卓 11：APPIOS 12：wap 13：小程序 20：pc
      index: 0,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.purchaseNum = this.$route.query.num;
    this.getInfo();
    var ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
      this.client = 11;
    } else if (/android/.test(ua)) {
      this.client = 10;
    }
  },
  methods: {
    getInfo() {
      this.$api
        .get("/investment/member/project/detail", { id: this.$route.query.id })
        .then((res) => {
          res.share_price += "";
          this.info = res;
          this.price_1 = this.info.share_price.split(".")[0];
          this.price_2 = this.info.share_price.split(".")[1] || "00";
          let amount = this.info.share_price * this.purchaseNum;
          amount += "";
          this.amount_1 = amount.split(".")[0];
          this.amount_2 = amount.split(".")[1] || "00";
        });
    },
    prev() {
      this.$router.go(-1);
    },
    submit() {
      if (this.info.member_order_exist) {
        let diff = this.info.target_shares - this.info.order_count.shares_sum;
        if (diff < this.purchaseNum && this.info.project_type == 1) {
          this.$toast("项目可购股数已不足" + this.purchaseNum + "股");
        } else {
          this.confirm();
        }
      } else {
        this.confirm();
      }
    },
    confirm() {
      this.index++;
      if (this.index > 1) {
        setTimeout(() => {
          this.index = 0;
        }, 1000);
        return;
      }
      this.$api
        .post("order/member/order/confirm", {
          //确认订单
          order: {
            //类型：Object  必有字段  备注：主订单必传参数
            type: "investment", //类型：String  必有字段  备注：订单类型 线上订单：onorder, 扫码订单：scan_order,线下报单：declaration_order,机票：air,酒店：hotel,众筹：investment,京东：jingdong,淘宝：taobao,油卡：oil,话费流量：rechargemobile,汽车：car，充值订单：recharge，会员升级：member_grade
          },
          project_id: this.info.id, //项目id
          shares: this.purchaseNum, //购买股数
        })
        .then((res) => {
          //创建订单参数
          var params = {
            order: {
              //类型：Object  必有字段  备注：主订单必传参数
              type: "investment", //类型：String  必有字段  备注：订单类型 线上订单：onorder, 扫码订单：scan_order,线下报单：declaration_order,机票：air,酒店：hotel,众筹：investment,京东：jingdong,淘宝：taobao,油卡：oil,话费流量：rechargemobile,汽车：car，充值订单：recharge，会员升级：member_grade
              client: this.client, //类型：Number  必有字段  备注：客户端类型 10：安卓 11：APPIOS 12：wap 13：小程序 20：pc
              confirm: res.order.confirm, //类型：Array  必有字段  备注：订单确认信息（以下信息有确认订单接口原封不动的返回即可）
            },
            project_id: this.info.id, //项目id
            shares: this.purchaseNum, //购买股数
          };
          this.$api
            .post("/order/member/order/create", params)
            .then((res) => {
              this.orderInfo = JSON.stringify(res);
              this.$refs.btn.click();
            })
            .catch((err) => {
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              //		    this.$toast(message);
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
              } else {
                this.$toast(message);
              }
            });
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //		    this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    investPay() {
      this.params(this.orderInfo, this.orderInfo, "investPay");
    },
  },
};
</script>
<style lang="less" scoped>
.zs {
  min-height: 100%;
  background-color: #f2f2f2;
  position: relative;
  .van-goods-action {
    .van-button {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #c49e80;
      border: none;
      img {
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 9px;
      }
    }
  }
  .invest {
    &-title {
      height: 44px;
      line-height: 44px;
      padding-top: 24px;
      box-shadow: 0 1px 0 #eee;
      .van-nav-bar__title {
        color: #333;
        font-size: 17px;
        font-weight: 700;
      }
    }
    &-reback {
      width: 15px;
      padding: 12px 15px;
      position: fixed;
      top: 29px;
      left: 0;
      z-index: 1;
    }
  }
  .addIn {
    padding-top: 69px;
    .prepare {
      background: #fff;
      padding-top: 16px;
      margin-bottom: 8px;
      .prepare_ {
        padding: 0 16px;
        position: relative;
        .border {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 16px;
          background-color: #c49e80;
        }
        .add-head {
          font-size: 18px;
          line-height: 25px;
          font-weight: 600;
          color: #333333;
          margin-left: 11px;
        }
      }
      .moments {
        padding: 0 16px;
        margin-top: 12px;
        margin-bottom: 16px;
        .moments_ {
          background-color: #f8f8f8;
          border-left: 3px solid #dddddd;
          padding-left: 12px;
          p {
            font-size: 15px;
            color: #777777;
            padding-bottom: 8px;
            line-height: 21px;
          }
          .project {
            padding-top: 12px;
          }
          .per_money {
            padding-bottom: 12px;
          }
        }
      }
    }
    .details {
      margin-bottom: 0px;
      padding-bottom: 16px;
      .prepare_ {
        padding: 0 16px;
        p {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          margin-bottom: 8px;
          span {
            color: #c49e80;
          }
          .zero {
            font-size: 12px;
          }
        }
        .join_num {
          margin-top: 12px;
        }
        .total {
          margin-bottom: 16px;
        }
      }
    }
  }
  .join- {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    line-height: 49px;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    background-color: #c49e80;
  }
}
.isiOSX {
  .invest {
    &-title {
      padding-top: 44px;
    }
    &-reback {
      top: 45px;
    }
  }
  .addIn {
    padding-top: 88px;
  }
}
</style>


